import { useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";

import { useDispatch } from "react-redux";

import {
	coursesProgressApi,
	useGetScenarioProgressQuery,
	useStartScenarioMutation,
} from "@/pages/Private/redux/course-progress/course-progress.api";

import { CourseProgressEnum } from "@/enum/course-progress.enum";

import { useAppSelector } from "@/redux/hooks";

import { authSelector } from "@/pages/Public/redux/auth.slice";

import { ERROR_TYPE } from "@/utils";

import { ROUTE_CONFIG } from "@/routes/config";

import { kpiApi } from "@/pages/Private/redux/kpi/kpi.api";

import { IStageContentInfo } from "../../Courses/constants/emptyCourseScenario";
import ContentModal from "../components/ContentModal";
import CourseInProgress from "../components/CourseInProgress";
import EndSession from "../components/EndSession";
import { SocketProvider } from "../context/SocketContext";
import { ScenarioActionTypes } from "../enums/ScenarioActionTypes.enum";
import { IEndSessionData } from "../interfaces/IEndSessionData.interface";

export default function CourseInProgressPage() {
	const { id } = useParams();
	const dispatch = useDispatch();
	const { data, isFetching, error } = useGetScenarioProgressQuery(id ? id : "");
	const [endSessionData, setEndSessionData] = useState<IEndSessionData | null>(null);
	const authState = useAppSelector(authSelector);
	const navigate = useNavigate();
	const [currentShowingContentInfo, setCurrentShowingContentInfo] =
		useState<IStageContentInfo | null>(null);
	const [startCourse] = useStartScenarioMutation();
	const currentUserAuth = useAppSelector((state) => state.auth?.user);

	if (error) {
		console.error("error", error);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onStartCourseRestartHandler = async (receivedData: any) => {
		setEndSessionData({
			scenarioName: receivedData.scenarioName,
			status: receivedData.status,
			additionalStatusInfo: receivedData?.additionalStatusInfo,
			isNotRestarted: false,
		});

		// Only the leader starts the new run; everyone else just sees this one end (BCM360-359).
		if (data?.course?.id !== -1 && currentUserAuth && currentUserAuth.id === data?.user?.id) {
			try {
				const result = await startCourse({
					courseId: data?.course?.id ?? -1,
					userId: currentUserAuth.id,
				}).unwrap();

				if (result?.id) {
					navigate(`${ROUTE_CONFIG.COURSES}/${result.id}/progress`);
				}
			} catch (err) {
				console.error(err);
			}
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function actionHandler(receivedData: any) {
		if (!receivedData?.type) {
			return;
		}

		switch (receivedData?.type) {
			case ScenarioActionTypes.NEW_STAGE:
				break;
			case ScenarioActionTypes.RESTART_SCENARIO:
				onStartCourseRestartHandler(receivedData);
				if (authState?.user?.id && data?.user?.id && authState.user.id !== data.user.id) {
					localStorage.removeItem("token");
				} else {
					dispatch(coursesProgressApi.util.invalidateTags(["CourseProgress"]));
				}

				break;
			case ScenarioActionTypes.FINISH_SCENARIO:
				setEndSessionData({
					scenarioName: receivedData.scenarioName,
					status: receivedData.status,
					additionalStatusInfo: receivedData?.additionalStatusInfo,
					isNotRestarted: true,
				});
				dispatch(kpiApi.util.invalidateTags(["Kpi"]));
				if (authState?.user?.id && data?.user?.id && authState.user.id !== data.user.id) {
					localStorage.removeItem("token");
				} else {
					dispatch(coursesProgressApi.util.invalidateTags(["CourseProgress"]));
				}

				setCurrentShowingContentInfo(null);
				break;
			case ScenarioActionTypes.SHOW_SPOILER:
				if (receivedData?.content) {
					setCurrentShowingContentInfo(receivedData.content);
				}

				break;
			case ScenarioActionTypes.LOGOUT:
				if (receivedData?.userId === authState?.user?.id) {
					localStorage.removeItem("token");
					navigate("/logout");
				}

				break;
			default:
				console.error("Received unknown action", receivedData?.type, data);
				break;
		}
	}

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		if ((error as any)?.data?.message === ERROR_TYPE.SCENARIO_INFO_NOT_FOUND) {
			setEndSessionData({
				additionalStatusInfo: "",
				status: CourseProgressEnum.NotStarted,
				scenarioName: "",
			});
		}
	}, [error]);

	if (isFetching || !data) {
		return (
			<div className="w-full flex-1 flex items-center justify-center">
				<CircularProgress className="!w-16 !h-16 !text-primary-gray" />
			</div>
		);
	}

	return (
		<SocketProvider
			courseId={id ? id : ""}
			currentAuth={authState}
			errInfo={data?.user}
			onActionHandler={actionHandler}
		>
			{endSessionData?.isNotRestarted ||
			data?.status === CourseProgressEnum.Failed ||
			data?.status === CourseProgressEnum.Success ? (
				<EndSession
					data={
						endSessionData ?? {
							status: data?.status ?? CourseProgressEnum.NotStarted,
							scenarioName: data?.course?.name ?? "",
							additionalStatusInfo: "already-end",
						}
					}
				/>
			) : (
				<>
					<CourseInProgress
						data={data}
						setCurrentShowingContentInfo={setCurrentShowingContentInfo}
					/>
					<ContentModal
						contentInfo={currentShowingContentInfo}
						setCurrentContentInfo={setCurrentShowingContentInfo}
					/>
				</>
			)}
		</SocketProvider>
	);
}
